import { useDispatch } from "react-redux";
import html2canvas from "html2canvas";
import { uploadFile } from "../../store/uploadFile";
import useGraphStore from "../../store/zustandStore/graphZs";

const useExportChartImage = () => {
  const dispatch = useDispatch();
  const { createGraphZs } = useGraphStore();

  const exportChart = async ({ chartRef, fileName, dataSetting }) => {
    if (!chartRef?.current) return;

    const canvas = await html2canvas(chartRef.current, {
      backgroundColor: null,
      scale: 2,
    });

    const blob = await new Promise((resolve) =>
      canvas.toBlob(resolve, "image/png")
    );

    const formData = new FormData();
    formData.append("file", blob, `${fileName}.png`);
    formData.append("filename", `${fileName}.png`);

    const response = await dispatch(uploadFile({ fileData: formData }));
    const uploadedFileId = response?.payload?.uplaodFileId;

    // Krijo nje format te dhenash ne name title_category

    if (uploadedFileId) {
      const newGraph = {
        title: fileName,
        chartTemplate: dataSetting?.chartTemplate,
        name: dataSetting?.name,
        formFormulaId: dataSetting?.formFormulaId,
        fileId: uploadedFileId,
        year: dataSetting?.year,
      };

      createGraphZs(newGraph);
    }
  };

  return exportChart;
};

export default useExportChartImage;
